import { Component, input } from '@angular/core';

import { CmsDisclaimer } from '@fcom/core-api';

@Component({
  selector: 'cms-disclaimer',
  styleUrls: ['./cms-disclaimer.component.scss'],
  templateUrl: './cms-disclaimer.component.html',
  standalone: false,
})
export class CmsDisclaimerComponent {
  content = input.required<CmsDisclaimer>();
}
